export default __webpack_public_path__ + "build/static/media/left.5e8ec503.svg";